import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "checkbox-container-tight d-flex justify-left align-center mt-7"
}
const _hoisted_2 = {
  key: 2,
  style: {"height":"180px"},
  class: "d-flex justify-center align-center"
}
const _hoisted_3 = {
  key: 3,
  style: {"height":"180px"},
  class: "d-flex justify-center align-center"
}
const _hoisted_4 = { style: {"word-break":"break-all"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      onClick: _ctx.onClickCard,
      disabled: _ctx.loading
    }, {
      default: _withCtx(() => [
        (_ctx.bulkDelFlg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.content.purchasedCount === 0)
                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 0,
                    modelValue: _ctx.computedBulkDelTarget,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedBulkDelTarget) = $event)),
                    value: _ctx.content.multimediaId,
                    disabled: _ctx.loading,
                    "hide-details": "",
                    density: "compact",
                    class: "tight-checkbox",
                    color: "primary",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    style: {"--v-selection-control-size":"40px","font-size":"1.5rem"}
                  }, null, 8, ["modelValue", "value", "disabled"]))
                : (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 1,
                    "hide-details": "",
                    density: "compact",
                    class: "tight-checkbox",
                    style: {"visibility":"hidden"}
                  }))
            ]))
          : _createCommentVNode("", true),
        (_ctx.content.status === 'completed')
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 1,
              src: _ctx.content.thumbnailUrl || '',
              sizes: "180px",
              height: "180px"
            }, null, 8, ["src"]))
          : (_ctx.content.status === 'failed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_chip, {
                  size: "small",
                  color: "error",
                  variant: "flat",
                  class: "text-white"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" 失敗 ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_chip, {
                  size: "small",
                  color: "secondary",
                  variant: "flat",
                  style: {"color":"white !important"}
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" 処理中 ", -1)
                  ]))]),
                  _: 1
                })
              ])),
        _createVNode(_component_v_card_text, { class: "pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_table, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _cache[6] || (_cache[6] = _createElementVNode("td", null, "種類", -1)),
                                _createElementVNode("td", null, [
                                  (_ctx.content.category === 'photo')
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "small",
                                        color: "success",
                                        variant: "flat"
                                      }, {
                                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                          _createTextVNode(" 写真 ", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        size: "small",
                                        color: "purple",
                                        variant: "flat"
                                      }, {
                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                          _createTextVNode(" 動画 ", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("td", null, "撮影日", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.content.date)), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", null, "単価", -1)),
                                _createElementVNode("td", null, "¥" + _toDisplayString(_ctx.content.price?.toLocaleString()), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("td", null, "購入数", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.content.purchasedCount), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", null, "売上", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.content.revenue), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("td", null, "ファイル名", -1)),
                                _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.content.filename), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[12] || (_cache[12] = _createElementVNode("td", null, "シリアルNO", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.content.serialNumber), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick", "disabled"])
  ]))
}